import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { EmptyFeeAgreement } from 'UI/res/images';

const { notAvailableStrings } = strings.inventoryProfiles.sections.jobOrders;

/**
 * Notice shown instead of the sendout form when the company of the job order is not signed.
 * @param {Object} props
 * @param {() => void} props.onClose Closes the drawer
 * @param {() => void} props.onGoToCompany Opens the company profile, where it can be signed
 */
export const UnavailableSendoutDrawer = ({ onClose, onGoToCompany }) => (
  <FPDrawer
    FPDrawerProps={{ open: true, onClose }}
    CardHeaderProps={{ title: notAvailableStrings.drawerTitle }}
    footer={null}
    onClose={onClose}
  >
    <EmptyPlaceholder
      title={notAvailableStrings.title}
      subtitle={notAvailableStrings.description}
      customEmptyState={<EmptyFeeAgreement />}
    >
      <FPActionButton
        text={notAvailableStrings.buttonTitle}
        type="button"
        onClick={onGoToCompany}
      />
    </EmptyPlaceholder>
  </FPDrawer>
);
